import { OrderDetailsText, } from "../../../Account/Orders/OrderDetailsAccordion/utils/OrderDetailsAccordion-types";
import { tokenReplace } from "../../utils/tokenReplacement";
export var DefaultRoutesText;
(function (DefaultRoutesText) {
    DefaultRoutesText["HOME"] = "Home";
    DefaultRoutesText["ACCOUNT"] = "My Account";
})(DefaultRoutesText || (DefaultRoutesText = {}));
export var Routes;
(function (Routes) {
    //Home route needs to use url from branding
    Routes["INDEX"] = "/";
    Routes["ACCOUNT"] = "/Account/*";
    Routes["LOGIN"] = "/Login";
    Routes["REGISTER"] = "/Register";
    Routes["ERROR"] = "/Error";
    Routes["THEME"] = "/Theme";
    Routes["INVALID_SKU"] = "/InvalidSku";
    Routes["PASSWORD_SET"] = "/PasswordSet";
    Routes["OVERLAPPING_ORDER_WARNING"] = "/OverlappingOrderWarning";
    Routes["GIFT_CARD"] = "/gift";
    Routes["GIFT_CARD_CHECKOUT"] = "/gift/Checkout";
    Routes["GIFT_CARD_THANK_YOU"] = "/gift/ThankYou";
    Routes["NOT_FOUND"] = "/404";
    Routes["PAYMENT_STATUS"] = "/PaymentStatus";
    //Nested sku routes /:sku/<route>
    Routes["SKU"] = "/:sku/*";
    Routes["BASE_SKU"] = "/:sku";
    Routes["LOCATION"] = "Location";
    Routes["CHECKOUT"] = "Checkout";
    Routes["THANK_YOU"] = "ThankYou";
    Routes["ORDER_FLOW"] = "OrderFlow";
    Routes["EDIT_FLOW"] = "EditFlow";
    Routes["SSO"] = "SSO";
    Routes["PAY"] = "/Pay";
})(Routes || (Routes = {}));
export var AccountRoutesDisplayText;
(function (AccountRoutesDisplayText) {
    AccountRoutesDisplayText["ORDERS"] = "Orders";
    AccountRoutesDisplayText["SKIP_DAYS"] = "Skip Days";
    AccountRoutesDisplayText["MY_MEALS"] = "My Meals";
    AccountRoutesDisplayText["SUBSCRIPTIONS"] = "Subscriptions";
    AccountRoutesDisplayText["ACCOUNT"] = "Account";
    AccountRoutesDisplayText["BILLING_INFO"] = "Billing";
    AccountRoutesDisplayText["PROFILE"] = "Profile";
    AccountRoutesDisplayText["LOGOUT"] = "Logout";
    AccountRoutesDisplayText["ADDRESSES"] = "Addresses";
})(AccountRoutesDisplayText || (AccountRoutesDisplayText = {}));
export var AccountRoutePath;
(function (AccountRoutePath) {
    AccountRoutePath["ORDERS"] = "Orders";
    AccountRoutePath["SKIP_DAYS"] = "SkipDays";
    AccountRoutePath["MY_MEALS"] = "MyMeals";
    AccountRoutePath["SUBSCRIPTIONS"] = "Subscriptions";
    AccountRoutePath["BILLING_INFO"] = "BillingInformation";
    AccountRoutePath["PROFILE"] = "Profile";
    AccountRoutePath["LOGOUT"] = "Logout";
    AccountRoutePath["ADDRESSES"] = "Addresses";
    AccountRoutePath["PAY"] = "Pay";
})(AccountRoutePath || (AccountRoutePath = {}));
export var AccountRoutesType;
(function (AccountRoutesType) {
    AccountRoutesType["ORDERS"] = "/Account/Orders";
    AccountRoutesType["SKIP_DAYS"] = "/Account/SkipDays";
    AccountRoutesType["MY_MEALS"] = "/Account/MyMeals";
    AccountRoutesType["SUBSCRIPTIONS"] = "/Account/Subscriptions";
    AccountRoutesType["BILLING_INFO"] = "/Account/BillingInformation";
    AccountRoutesType["PROFILE"] = "/Account/Profile";
    AccountRoutesType["LOGOUT"] = "/Account/Logout";
    AccountRoutesType["ADDRESSES"] = "/Account/Addresses";
    AccountRoutesType["NOT_FOUND"] = "/Account/404";
    AccountRoutesType["ACCOUNT_MENU"] = "AccountMenu";
})(AccountRoutesType || (AccountRoutesType = {}));
/**
 * Uses URL constructor to validate the url string.
 *
 * If its a valid url the URL constructor returns a URL object.
 * If its an invalid url, the URL constructor returns a TypeError.
 *
 * @param url
 * @returns
 */
export const isValidUrl = (url) => {
    try {
        const newUrl = new URL(url);
        return true;
    }
    catch (err) {
        return false;
    }
};
// TODO: Implement elsewhere?
export const navBarMobileLogoStyles = {
    maxWidth: "100%",
    maxHeight: "50px",
    padding: "10px 0",
};
// TODO: Implement elsewhere?
export const navBarDesktopLogoStyles = {
    maxWidth: "250px",
    maxHeight: "90px",
    padding: "10px 0",
};
export const getNavItems = (MyMealsLinkText) => [
    {
        displayText: AccountRoutesDisplayText.ORDERS,
        to: AccountRoutesType.ORDERS,
        menuItems: null, // Standalone link, not part of any menu
    },
    {
        displayText: AccountRoutesDisplayText.SKIP_DAYS,
        to: AccountRoutesType.SKIP_DAYS,
        menuItems: null, // Standalone link, not part of any menu
    },
    {
        // My Meals Menu
        displayText: MyMealsLinkText !== null && MyMealsLinkText !== void 0 ? MyMealsLinkText : AccountRoutesDisplayText.MY_MEALS,
        to: AccountRoutesType.MY_MEALS,
        menuItems: null, // This is a standalone menu trigger (not part of any other menu)
    },
    {
        displayText: AccountRoutesDisplayText.SUBSCRIPTIONS,
        to: AccountRoutesType.SUBSCRIPTIONS,
        menuItems: null, // Standalone link, not part of any menu
    },
    {
        displayText: AccountRoutesDisplayText.ACCOUNT,
        to: AccountRoutesType.ACCOUNT_MENU,
        menuItems: [
            // Sub-menu items nested within this account menu
            {
                displayText: AccountRoutesDisplayText.BILLING_INFO,
                to: AccountRoutesType.BILLING_INFO,
                menuItems: null, // Not part of a further nested menu
            },
            {
                displayText: AccountRoutesDisplayText.ADDRESSES,
                to: AccountRoutesType.ADDRESSES,
                menuItems: null, // Not part of a further nested menu
            },
            {
                displayText: AccountRoutesDisplayText.PROFILE,
                to: AccountRoutesType.PROFILE,
                menuItems: null, // Not part of a further nested menu
            },
        ],
    },
    {
        displayText: AccountRoutesDisplayText.LOGOUT,
        to: AccountRoutesType.LOGOUT,
        menuItems: null, // Standalone link, not part of any menu
    },
];
// Function to get the correct button text based on conditions
export const getChooseOrReviewMealsButtonText = (canReviewOrChooseMeals, AllMealDaysPastCutOff, tokenMap) => {
    if (canReviewOrChooseMeals && AllMealDaysPastCutOff) {
        return tokenReplace(OrderDetailsText.REVIEW_MEALS, false, tokenMap);
    }
    else if (canReviewOrChooseMeals && !AllMealDaysPastCutOff) {
        return tokenReplace(OrderDetailsText.CHOOSE_MEALS, false, tokenMap);
    }
    else {
        return tokenReplace(OrderDetailsText.CHOOSE_MEALS, false, tokenMap); // Default text
    }
};
// Function to handle button click and navigate accordingly
export const chooseOrReviewMealsButtonClickHandler = (setSelectedSubLinkId, subscriptionLinkId, canReviewOrChooseMeals, navigate, orderNumber, canChooseMeals, mappedMeals) => {
    var _a;
    // Set selected subscription link ID first
    setSelectedSubLinkId(subscriptionLinkId);
    // determine where to navigate based on conditions
    if (canReviewOrChooseMeals) {
        navigate(AccountRoutesType.MY_MEALS, {
            state: { orderNumber: orderNumber, allowPastcutoff: true },
        });
    }
    else if (canChooseMeals) {
        navigate(AccountRoutesType.MY_MEALS, {
            state: {
                orderNumber: orderNumber,
                allowPastcutoff: true,
                futureOrderDates: { start: mappedMeals[0].day, end: (_a = mappedMeals === null || mappedMeals === void 0 ? void 0 : mappedMeals.at(-1)) === null || _a === void 0 ? void 0 : _a.day },
            },
        });
    }
};
